import {RouteDefinition} from '../../../routes';
import {RoomListScreen} from './RoomListScreen';
import {AreaListScreen} from './AreaListScreen';
import {RoomEditScreen} from './RoomEditScreen';
import {AreaEditScreen} from './AreaEditScreen';

export const ProjectInformationSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/project-information',
        component: AreaListScreen,
    },
    {
        routerLink: '/settings/area/edit',
        component: AreaEditScreen,
    },
    {
        routerLink: '/settings/area/edit/:id',
        component: AreaEditScreen,
    },
    {
        routerLink: '/settings/floor/:id/room',
        component: RoomListScreen,
    },
    {
        routerLink: '/settings/floor/:floor_id/room/edit',
        component: RoomEditScreen,
    },
    {
        routerLink: '/settings/floor/:floor_id/room/edit/:id',
        component: RoomEditScreen,
    },
];
